import * as React from "react";
import { useParams } from "react-router-dom";
import { toast } from "sonner";
import CustomerDescCard from "src/components/customer-desc-card/customer-desc-card";
import customersQueries from "src/queries/customer-queries";
import { EntityDrawer } from "@/components/entity-drawer";

const CustomerDetailView: React.FC = () => {
	const { customerId } = useParams<{ customerId: string }>();
	const getCustomer = customersQueries.getCustomer();

	const [customer, setCustomer] = React.useState<
		Awaited<ReturnType<typeof getCustomer.mutateAsync>> | undefined
	>(undefined);

	// biome-ignore lint/correctness/useExhaustiveDependencies: getCustomer.mutateAsync is stable
	React.useEffect(() => {
		if (customerId) {
			getCustomer
				.mutateAsync(customerId)
				.then((data) => setCustomer(data))
				.catch((error) => {
					console.error("Failed to load customer:", error);
					toast.error("Failed to load customer details");
				});
		}
	}, [customerId]);

	const openNotification = (title: string, description: string) => {
		toast.success(title, {
			description,
		});
	};

	return (
		<EntityDrawer
			title="Customer details"
			isLoading={getCustomer.isPending && !customer}
			isNotFound={
				!getCustomer.isPending && !customer && customerId !== undefined
			}
			notFoundMessage="Customer not found"
			parentPath="/payments/customers"
		>
			{customer && (
				<CustomerDescCard
					data={customer}
					openNotificationFunc={openNotification}
				/>
			)}
		</EntityDrawer>
	);
};

export default CustomerDetailView;
